import {TextField} from '@material-ui/core';
import Autocomplete, {createFilterOptions} from '@material-ui/lab/Autocomplete';
import { useEffect, useState } from 'react';
import { useController } from 'react-hook-form';

const filter = createFilterOptions();

export default function CreatableSelectBox({
  optionList, 
  control, 
  rules,
  fieldId = 'creatable-select-box', 
  label, 
  name, 
  createButtonPrefix, 
  required, 
  errors
}) {
  const { 
    field: { value ,onChange, ref }
  } = useController({control, name, rules})

  const [structuredValue, setStructuredValue] = useState({title: value, inputValue: value})

  const handleDataChanging = (event, newValue) => {
    console.log({event,newValue});
    if (typeof newValue === 'string') {
      onChange(newValue);
    } else if (newValue && newValue.inputValue) {
      // Create a new value from the user input
      console.log(newValue);
      onChange(newValue.inputValue);
    } else {
      onChange(newValue);
    }
  }

  const handleFiltering = (options, params) => {
    console.log({options, params})
    const filtered = filter(options, params);

    // Suggest the creation of a new value
    if (params.inputValue !== '') {
      filtered.push({
        inputValue: params.inputValue,
        title: `${createButtonPrefix} "${params.inputValue}"`,
      });
    }

    return filtered;
  }

  useEffect(() => {
    setStructuredValue({title: value,inputValue: value})
  },[value])

  return (
    <Autocomplete
      value={structuredValue}
      onChange={(event, newValue) => handleDataChanging(event, newValue)}
      filterOptions={(option,params) => handleFiltering(option,params)}
      selectOnFocus
      clearOnBlur
      handleHomeEndKeys
      id={fieldId}
      options={optionList}
      getOptionLabel={(option) => {
        // Value selected with enter, right from the input
        if (typeof option === 'string') {
          return option;
        }
        // Add "xxx" option created dynamically
        if (option.inputValue) {
          return option.inputValue;
        }
        // Regular option
        return option.title
      }}
      renderOption={(option) => option.title}
      freeSolo
      renderInput={(params) => <TextField 
          {...params} 
          required={required} 
          label={label} 
          name={name}
          variant="outlined"
          error={errors?.[name] ? true : false}
          helperText={errors?.[name] ? errors?.[name].message : null}
         />}
    />
  );
}
